import { render, staticRenderFns } from "./Booking.vue?vue&type=template&id=6456431a&"
import script from "./Booking.vue?vue&type=script&lang=js&"
export * from "./Booking.vue?vue&type=script&lang=js&"
import style0 from "./Booking.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports